<template>
	<v-container fluid>
		<v-radio-group v-model="code">
			<v-radio
				v-for="(item, i) in items"
				:key="i"
				:label="item.val"
				:value="item.code"
				color="#FF4B83"
			></v-radio>
		</v-radio-group>
		<v-textarea
			label="신고 사유를 적어주세요"
			counter="500"
			outlined
			rows="5"
			v-model="content"
			:maxlength="500"
		></v-textarea>
		<v-btn
			depressed
			block
			large
			color="#EE1F60"
			style="color: #ffffff"
			class="text-subtitle-1"
			:disabled="diableFlag"
			@click="submit()"
		>
			등록하기
		</v-btn>
	</v-container>
</template>

<script>
import { APP_URL } from "../api/index";
import store from "@/store";
import { reportCheck } from "../api/index";

export default {
	name: "Report",
	data() {
		return {
			item: store.state,
			radioGroup: 1,
			items: store.state.reportOption,
			code: "",
			content: "",
		};
	},
	computed: {
		diableFlag() {
			return false;
			// return (
			// 	this.code === "" || (this.code === "9" && this.content === "")
			// );
		},
	},
	methods: {
		async submit() {
			if ("Y" == this.item.loginYn || "Y" == this.item.detail.loginYn) {
				if ("" == this.code) {
					alert("신고사유를 입력해주세요");
				} else if (this.code === "9" && this.content.length < 10) {
					alert("사유는 10자 이상 입력해주세요");
				} else {
					try {
						const check = await axios.get(
							APP_URL +
								"/knownew/estimate/productReviewReportCheck.gs",

							{
								params: {
									prdrevwId: this.$route.params.messageId,
								},
								withCredentials: true,
							}
						);

						if (!!check.data && !!check.data.errorFlg) {
							alert(check.data.errorMsg);
							return;
						}

						const formData = new FormData();
						formData.append(
							"prdrevwId",
							this.$route.params.messageId
						);
						formData.append("declrTyp", this.code);
						formData.append("declrRsn", this.content);

						const response = await axios.post(
							APP_URL +
								"/knownew/estimate/productRevwReportProcess.gs",
							formData,
							{ withCredentials: true } // 쿠키를 포함하도록 설정
						);

						let reportResultMsg = "";
						if (response.data.procFlg == "Y") {
							reportResultMsg = response.data.procMsg;
						} else {
							reportResultMsg = "잠시 후 다시 시도해주세요.";
						}
						alert(reportResultMsg);
						history.back();
					} catch (error) {
						console.log(error);
						alert("오류가 발생했습니다. 다시 시도해주세요.");
					}
				}
			} else {
				//location.origin + '/list/' + 1056606213
				var loginUrl =
					APP_URL +
					"/member/logIn.gs?returnurl=" +
					location.origin +
					"/list/" +
					this.$route.params.prdcd;
				if ("Y" == store.state.appYn) {
					loginUrl = "toapp://login?param=" + location.href;
				}
				location.href = loginUrl;
			}
		},
	},
};
</script>